import { Injectable } from "@angular/core";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { ModalConfirmComponent } from "./modal-confirm/modal-confirm.component";
import { ModalSuccessComponent } from "./modal-success/modal-success.component";
import { ModalErrorComponent } from "./modal-error/modal-error.component";

export type availableModalNameType =
  | "confirm-modal"
  | "success-modal"
  | "error-modal";

export type SharedModalDataType<T> = {
  title: string;
  body: string;
  optionalData?: T;
};

@Injectable({
  providedIn: "root",
})
export class ModalSharedServiceService {
  protected modalData: any;
  constructor(private modalService: NgbModal) {}
  openModal<Z>(
    modalName: availableModalNameType,
    modalData?: SharedModalDataType<Z>
  ): Promise<boolean> {
    return new Promise<boolean>(resolve => {
      let modalRef: NgbModalRef;
      switch (modalName) {
        case "confirm-modal":
          modalRef = this.modalService.open(ModalConfirmComponent, {
            size: "md",
            centered: true,
            backdrop: "static",
          });
          break;
        case "success-modal":
          modalRef = this.modalService.open(ModalSuccessComponent, {
            size: "sm",
            centered: true,
            backdrop: "static",
          });
          break;
        case "error-modal":
          modalRef = this.modalService.open(ModalErrorComponent, {
            size: "sm",
            centered: true,
            backdrop: "static",
          });
          break;
        default:
          throw new Error("Modal not Found, Select One");
      }
      if (!modalRef) {
        return;
      }
      modalRef.componentInstance.data = modalData ? modalData : null;
      // Return Accept
      modalRef.componentInstance.pressedConfirm.subscribe(() => {
        resolve(true);
        modalRef.close();
      });
      // Return Cancel
      modalRef.componentInstance.pressedCancel.subscribe(() => {
        resolve(false);
        modalRef.close();
      });
    });
  }
}
